export default {
  effects: {
    captions: {
      blur: 'Vervagen',
      crop: 'Bijknippen',
      enhance: 'Verbeteren',
      flip: 'Omkeren',
      grayscale: 'Zwart-wit',
      invert: 'Inverteren',
      mirror: 'Spiegelen',
      rotate: 'Roteren',
      sharp: 'Verscherpen',
    },
    apply: 'Toepassen',
  },
}
